var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePlaceholderSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 330,
    viewBox: "0 0 330 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.982 0H7.01833C3.14221 0 0 2.55225 0 5.70061V324.299C0 327.448 3.14221 330 7.01833 330H322.982C326.858 330 330 327.448 330 324.299V5.70061C330 2.55225 326.858 0 322.982 0Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.671 131.796L91.0092 150.282C86.5859 151.587 84.0515 156.252 85.3486 160.702L105.955 231.401C107.252 235.852 111.889 238.401 116.313 237.096L178.974 218.611C183.398 217.306 185.932 212.64 184.635 208.19L164.029 137.491C162.732 133.041 158.094 130.491 153.671 131.796Z",
    fill: "#9F9F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.567 119.011L148.471 91.2916C146.049 90.5783 143.512 91.9749 142.803 94.411L112.979 196.882C112.27 199.318 113.658 201.871 116.08 202.584L210.176 230.304C212.597 231.017 215.135 229.62 215.844 227.184L245.668 124.713C246.377 122.277 244.989 119.724 242.567 119.011Z",
    fill: "url(#paint0_linear_201_34)",
    stroke: "white",
    strokeWidth: 5.398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.397 127.31L152.512 103.483L130.811 178.046L211.695 201.874L233.397 127.31Z",
    fill: "#CCCCCC",
    stroke: "white",
    strokeWidth: 2.25674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.397 127.31L152.512 103.483L142.385 138.279L223.269 162.106L233.397 127.31Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.25674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.326 139.735L156.243 132.73L168.39 128.183L170.11 132.032L174.218 126.282L175.712 126.186L179.265 122.158L200.23 160.716",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.326 139.735L156.243 132.73L168.39 128.183L170.11 132.032L174.218 126.282L175.712 126.186L179.265 122.158L200.23 160.716",
    stroke: "white",
    strokeWidth: 2.25674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.264 122.158C179.144 125.086 178.94 128.011 178.652 130.927C178.434 133.141 178.168 135.35 177.854 137.551L174.565 135.295L168.389 128.183L167.027 136.134L165.566 140.163L165.757 145.684L178.377 147.287L193.241 147.863L189.103 132.714L186.785 134.717L183.384 129.735L179.264 122.158Z",
    fill: "#B3B3B3",
    stroke: "white",
    strokeWidth: 2.25674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.643 150.528L182.721 142.168L186.236 141.462L192.262 135.288L197.581 132.951L218.547 171.509",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.643 150.528L182.721 142.168L186.236 141.462L192.262 135.288L197.581 132.951L218.547 171.509",
    stroke: "white",
    strokeWidth: 2.25674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.582 132.951L199.599 148.101L198.147 153.091L196.695 158.08L199.455 162.395C200.841 161.643 202.354 161.129 203.909 160.882C206.688 160.44 209.522 160.851 212.335 160.913C213.477 160.938 214.646 160.901 215.714 160.492C215.986 160.388 216.249 160.261 216.5 160.112L211.559 158.657L206.841 149.971L204.282 140.417L202.167 141.384L197.582 132.951Z",
    fill: "#B3B3B3",
    stroke: "white",
    strokeWidth: 2.25674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.516 185.324C155.91 183.713 154.912 181.979 159.815 181.073C165.83 179.963 182.281 181.235 187.767 178.516C191.827 176.505 177.987 168.858 181.555 166.059C183.172 164.789 192.241 165.614 196.544 165.028C200.623 164.472 199.993 162.481 203.162 161.585C206.223 160.719 215.373 161.624 216.499 160.112C214.277 161.35 204.179 160.153 200.23 160.716C196.062 161.311 195.733 162.977 190.667 163.204C185.209 163.447 174.994 162.284 172.279 163.277C166.593 165.356 177.943 172.609 172.054 174.005C164.079 175.895 145.37 173.933 137.198 174.531C131.552 174.944 131.664 176.094 130.811 178.046",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.516 185.324C155.91 183.713 154.912 181.979 159.815 181.073C165.83 179.963 182.281 181.235 187.767 178.516C191.827 176.505 177.987 168.858 181.555 166.059C183.172 164.789 192.241 165.614 196.544 165.028C200.623 164.472 199.993 162.481 203.162 161.585C206.223 160.719 215.373 161.624 216.499 160.112C214.277 161.35 204.179 160.153 200.23 160.716C196.062 161.311 195.733 162.977 190.667 163.204C185.209 163.447 174.994 162.284 172.279 163.277C166.593 165.356 177.943 172.609 172.054 174.005C164.079 175.895 145.37 173.933 137.198 174.531C131.552 174.944 131.664 176.094 130.811 178.046",
    stroke: "white",
    strokeWidth: 2.25674,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_34",
    x1: 207.115,
    y1: 114.093,
    x2: 176.708,
    y2: 211.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholderSquare);
export default __webpack_public_path__ + "static/media/image-placeholder-square.d75bbec4c9687f907f2463a35b74c4d5.svg";
export { ForwardRef as ReactComponent };